import React, { Component, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import {Link} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import NumberFormat from 'react-number-format';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw, RichUtils } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {postOnePost, updatePost, getPost, clearErrors} from '../../../redux/actions/postsActions';
import {getAllCategoriesWeb} from '../../../redux/actions/categoriesActions';
import {clearImageSelected} from '../../../redux/actions/getImageActions';
import {clearImage} from '../../../redux/actions/imageActions';
import ImageFolder from '../../../util/ImageFolder';
import {DateFormatInput} from 'material-ui-next-pickers';
import dayjs from 'dayjs';
import BrowserSearch from '../../../util/BrowserSearch';
import SEOAnalysis from '../../../util/SEOAnalysis';
import {mediaBlockRenderer} from '../../../util/InsertRenderToRDW'
import InsertYoutube from '../../../util/RDW/InsertYoutube';
import Common from '../../Common';
import SentSuccessfully from '../../../util/SentSuccessfully';
import Loader from '../../../util/Loader';
import AppBarSEO from '../../AppBarSEO';
import ShowKeywords from '../../ShowKeywords';
import SubmitCheck from './SubmitCheck';

const styles = theme => ({
  ...theme,
  checkBox: {
    padding: '0 12px',
    color: '#d7d7d7',
  },
  childCategory: {
    marginLeft: 20,
  },
  boxApp: {
    position: 'sticky',
    top: 110,
    left: 0,
    right: 0,
    zIndex: 99,
    backgroundColor: '#000',
    borderBottom: '1px solid #d7d7d7',
    display: 'flex',
    padding: 10,
    '& .rightButton': {
      marginLeft: 'auto',
    }
  },
  showSEO: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    fontSize: 14,
    '& .boxColor': {
      display: 'inline-block',
      width: 16,
      height: 16,
      marginRight: 8,
      borderRadius: '50%',
      transition: 'all 0.5s ease',
    },
    '& .boxColor.success': {
      backgroundColor: '#00ab66',
    },
    '& .boxColor.warning': {
      backgroundColor: '#ffce07',
    },
    '& .boxColor.danger': {
      backgroundColor: '#ff3d00',
    },
    '& .boxColor.bgDark': {
      backgroundColor: '#555555',
    }
  },
  boxFlex: {
    display: 'flex',
    '& .ml-auto': {
      marginLeft:'auto',
    }
  },
  box: {
    padding: '0 10px 10px',
    backgroundColor: '#000',
    border: '1px solid #d7d7d7',
    borderRadius: 4,
  },
  dateInput: {
    '& div div div:first-child': {
      fontSize: 12,
      padding: '10px 0 25px',
    },
    '& div div div:last-child': {
      marginLeft: -38,
    },
  },
  itemWrapper: {
    position: 'relative',
    padding: 20,
    borderBottom: '1px solid #d7d7d7',
    '&:last-child': {
      borderBottom: 0,
    },
    '& p:last-child': {
      marginBottom: 0,
    }
  },
  formEdit: {
    position: 'relative',
    padding: '5px 10px',
    border: '1px solid #eee',
    borderRadius: 4,
    marginTop: 15,
  },
  marginGrid: {
    outline: '1px solid #d7d7d7',
    backgroundColor: '#000',
  },
  showImageAlbum: {
    margin: '20px 0 10px',
    textAlign: 'center',
  },
  imageRender: {
    display: 'inline-block',
    width: 180,
    height: 180,
    backgroundColor: '#000',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    marginLeft: 5,
    position: 'relative',
    '& svg': {
      position: 'absolute',
      right: -5,
      top: -5,
      backgroundColor: '#000',
      borderRadius: '50%',
      cursor: 'pointer',
    }
  },
  boxMessage: {
    position: 'fixed',
    top: 80,
    right: 15,
    zIndex: 101,
    backgroundColor: '#d5ffce',
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    borderRadius: 4,
    fontWeight: 500,
    color: '#d7d7d7',
    '& svg': {
      fontSize: 14,
      marginLeft: 15,
      backgroundColor: '#000',
      borderRadius: '50%',
      padding: 2,
      alignSelf: 'center',
      verticalAlign: 'middle',
      cursor: 'pointer',
    }
  }
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      // prefix="$ "
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      featuredImg: null,
      title_vi: '',
      title_en: '',
      title_ko: '',
      meta_title_vi: '',
      meta_title_ko: '',
      meta_title_en: '',
      meta_description_vi: '',
      meta_description_ko: '',
      meta_description_en: '',
      meta_keywords_vi: '',
      meta_keywords_ko: '',
      meta_keywords_en: '',
      description_vi: '',
      description_ko: '',
      description_en: '',
      categories: [],
      status: 1,
      password: '',
      slug: '',
      createdAt: new Date(),
      success: {},
      settingsCol: true,
      openShowActive: false,
      onShowActivePw: false,
      openShowCreatedAt: false,
      openNewCreatedAt: false,
      openSuccess: false,
      openErrors: false,
      domain: 'ntea.vn',
      language: 'vi',
    }
  }
  componentDidMount() {
    if(this.props.match.params.postId) {
      this.props.getPost(this.props.match.params.postId)
    }
    this.props.getAllCategoriesWeb('ntea.vn');
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.match.params.postId) {
      if(nextProps.posts.post) {
          const post = nextProps.posts.post;
          this.setState({
              title_vi: post.title ? post.title.vi ? post.title.vi : '' : '',
              title_en: post.title ? post.title.en ? post.title.en : '' : '',
              title_ko: post.title ? post.title.ko ? post.title.ko : '' : '',
              description_vi: post.description ? post.description.vi ? this.convertDescription(post.description.vi) : '' : '',
              description_en: post.description ? post.description.en ? this.convertDescription(post.description.en) : '' : '',
              description_ko: post.description ? post.description.ko ? this.convertDescription(post.description.ko) : '' : '',
              featuredImg: post.featuredImg ? post.featuredImg : '',
              slug: post.slug ? post.slug : '',
              categories: post.categories ? post.categories : [],
              featuredImage: post.featuredImage ? post.featuredImage : '',
              meta_title_vi: post.meta_title ? post.meta_title.vi ? post.meta_title.vi : '' : '',
              meta_title_en: post.meta_title ? post.meta_title.en ? post.meta_title.en : '' : '',
              meta_title_ko: post.meta_title ? post.meta_title.ko ? post.meta_title.ko : '' : '',
              meta_description_vi: post.meta_description ? post.meta_description.vi ? post.meta_description.vi : '' : '',
              meta_description_en: post.meta_description ? post.meta_description.en ? post.meta_description.en : '' : '',
              meta_description_ko: post.meta_description ? post.meta_description.ko ? post.meta_description.ko : '' : '',
              meta_keywords_vi: post.meta_keywords ? post.meta_keywords.vi ? post.meta_keywords.vi : '' : '',
              meta_keywords_en: post.meta_keywords ? post.meta_keywords.en ? post.meta_keywords.en : '' : '',
              meta_keywords_ko: post.meta_keywords ? post.meta_keywords.ko ? post.meta_keywords.ko : '' : '',
              status: post.status ? post.status : 1,
              password: post.password ? post.password : '',
              createdAt: post.createdAt ? new Date(post.createdAt) : new Date(),
              domain: post.domain ? post.domain : '',
          });
      }
    }
    if(nextProps.get_image.imageUrl) {
      this.setState({
        featuredImg: nextProps.get_image.imageUrl
      })
    }
  }
  
  convertDescription = (data) => {
    const blocksFromHtml = htmlToDraft(data, (nodeName, node) => {
      if (nodeName === 'img') {
        return {
          type: 'image',
          mutability: 'MUTABLE',
          data: {
            src: node.src,
            alt: node.alt,
          }
        };
      } else if (nodeName === 'iframe') {
        return {
          type: 'youtube',
          mutability: 'MUTABLE',
          data: {
            id: node.id,
            width: node.width,
            height: node.height,
          }
        };
      }
    });
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const bodyState = EditorState.createWithContent(contentState);
    return bodyState;
  }
handleChange = (event) => {
  this.setState({
    [event.target.name]: event.target.value
  })
};
onDescriptionChange = (description) => {
  const {language} = this.state;
  language === 'en' ? this.setState({description_en: description}) : language === 'ko' ? this.setState({description_ko: description}) : this.setState({description_vi: description});
};
handleKeyCommand = (command) => {
  const {description_en, description_ko, description_vi, language} = this.state;
  const newState = RichUtils.handleKeyCommand(language === 'en' ? description_en : language === 'ko' ? description_ko : description_vi, command);
  if (newState) {
    this.onDescriptionChange(newState);
    return true;
  }
  return false;
}
handleSubmit = (event) => {
  event.preventDefault();
  const {title_vi, description_vi, slug, categories, featuredImg, domain} = this.state;
  var success = {};
  domain ? success.domain = true : this.setState({openErrors: true});
  title_vi ? success.title_vi = true : this.setState({openErrors: true});
  description_vi ? success.description_vi = true : this.setState({openErrors: true});
  slug ? success.slug = true : this.setState({openErrors: true}); 
  featuredImg ? success.featuredImg = true : this.setState({openErrors: true});
  categories.length > 0 ? success.categories = true : this.setState({openErrors: true});
  this.setState({
    success,
    openSuccess: true,
  })
}
sendData = () => {
  const customEntityTransform = (entity, text) => {
    if (entity.type === 'image') return `<img src=${entity.data.src} alt=${entity.data.alt} /></p>${entity.data.note ? '<p><em>'+entity.data.note+'</em></p>' : ''}`;
    else if (entity.type === 'youtube') return `<iframe id=${entity.data.id} title=${entity.data.id} width=${entity.data.width} height=${entity.data.height} src='https://www.youtube.com/embed/${entity.data.id}' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullscreen />`;
    else return;
  };    
  const {title_vi, title_en, title_ko, description_vi, description_en, description_ko, slug, categories, featuredImg, meta_title_vi, meta_title_en, meta_title_ko, meta_description_vi, meta_description_en, meta_description_ko, meta_keywords_vi, meta_keywords_en, meta_keywords_ko, status, password, createdAt, domain} = this.state;
  const rawContentState_vi = description_vi ? convertToRaw(description_vi.getCurrentContent()) : '';
  const rawContentState_en = description_en ? convertToRaw(description_en.getCurrentContent()) : '';
  const rawContentState_ko = description_ko ? convertToRaw(description_ko.getCurrentContent()) : '';
  const convert_description_vi = rawContentState_vi ? draftToHtml(rawContentState_vi, {}, false, customEntityTransform) : '';
  const convert_description_en = rawContentState_en ? draftToHtml(rawContentState_en, {}, false, customEntityTransform) : '';
  const convert_description_ko = rawContentState_ko ? draftToHtml(rawContentState_ko, {}, false, customEntityTransform) : '';
  const dataPost = {
    title: {
      vi: title_vi,
      en: title_en,
      ko: title_ko,
    },
    description: {
      vi: convert_description_vi,
      en: convert_description_en,
      ko: convert_description_ko,
    },
    slug,
    categories,
    featuredImg,
    meta_title: {
      vi: meta_title_vi,
      en: meta_title_en,
      ko: meta_title_ko,
    },
    meta_description: {
      vi: meta_description_vi,
      en: meta_description_en,
      ko: meta_description_ko,
    },
    meta_keywords: {
      vi: meta_keywords_vi,
      en: meta_keywords_en,
      ko: meta_keywords_ko,
    },
    status,
    password,
    createdAt,
    domain,
  }
  if(this.props.match.params.postId) {
    const postId = this.props.match.params.postId;
    this.props.updatePost(postId, dataPost, this.props.history);
    this.cancelPublic();
    this.props.clearImageSelected();
    this.props.clearImage();
  } else {
    this.props.postOnePost(dataPost, this.props.history);
    this.cancelPublic();
    this.props.clearImageSelected();
    this.props.clearImage();
  }
}
cancelPublic = () => {
  this.setState({
    errors: {},
    openSuccess: false,
    openErrors: false,
  })
}
pushCategories = (e) => {
  const categories = this.state.categories;
  const check_exits = categories.filter((category => category.value === e.value))
  if(check_exits.length > 0) {
    const index = categories.findIndex((category) => category.value === e.value);
    categories.splice(index, 1);
    this.setState({
      categories
    })
  } else {
    categories.push(e);
    this.setState({
      categories
    })
  }
}
toggleSettings = () => {
  this.setState({
    settingsCol: !this.state.settingsCol,
  })
}
toggeShowActive = () => {
  this.setState({
    openShowActive: !this.state.openShowActive,
  })
}
toggeShowCreatedAt = () => {
  this.setState({
    openShowCreatedAt: !this.state.openShowCreatedAt,
  })
}
confirmActivePw = (e) => {
  if (e.key === 'Enter') {
    this.setState({
      status: 2,
      openShowActive: false,
    })
  }
}
changeActive = (e) => {
  if(e === 2) {
    this.setState({
      onShowActivePw: true,
    })
  } else {
    this.setState({
      active: e,
      openShowActive: false,
      password: '',
    })
  }
}
onChangeCreatedAt = date => {
  this.setState({ createdAt: date, openShowCreatedAt: false, openNewCreatedAt: true, });
};
clearMessage = () => {
  this.props.clearErrors();
}
  render() {
    const {classes, posts: { loading }, message } = this.props;
    const { 
      success, 
      featuredImg,
      title_en,
      title_ko,
      title_vi,
      categories,
      description_en,
      description_vi,
      description_ko,
      meta_title_en,
      meta_title_ko,
      meta_title_vi,
      meta_description_en, 
      meta_description_vi, 
      meta_description_ko, 
      meta_keywords_en,
      meta_keywords_vi, 
      meta_keywords_ko,  
      slug,
      password,
      createdAt,
      settingsCol,
      openShowActive,
      onShowActivePw,
      openShowCreatedAt,
      openNewCreatedAt,
      status,
      domain,
      openSuccess,
      openErrors,
      language,
    } = this.state;
    const get_cate = this.props.categories.categories_web.filter(category => category.parentId.length === 0);
    const album_images = featuredImg && <div className={classes.imageRender} style={{backgroundImage: `url(${featuredImg})`}} />
    return (
      <Fragment>
        <Common />
        {message && <SentSuccessfully message={message} clearMessage={() => this.clearMessage()} />}
        {loading && <Loader />}
        <SubmitCheck 
          openSuccess={openSuccess} 
          openErrors={openErrors} 
          success={success} 
          cancelPublic={this.cancelPublic}
          sendData={this.sendData}
        />
          <div className={classes.boxApp}>
            <div className={classes.showSEO}>
              <AppBarSEO meta_title={language === 'en' ? meta_title_en : language === 'ko' ? meta_title_ko : meta_title_vi} meta_description={language === 'en' ? meta_description_en : language === 'ko' ? meta_description_ko : meta_description_vi} meta_keywords={language === 'en' ? meta_keywords_en : language === 'ko' ? meta_keywords_ko : meta_keywords_vi} />
            </div>
            <div className="rightButton">
                <Link to='/bai-viet' className="btn btn-light mr-5">
                    Trở lại
                </Link>
                <button
                    onClick={this.handleSubmit}
                    className="btn btn-primary"
                    disabled={this.props.loading}
                >
                    {this.props.loading ? (
                            <><i className="fas fa-spinner fa-pulse" /> Đang tải</>
                    ) :
                    this.props.match.params.postId ? 'Cập nhật' : 'Công bố'
                    }
              </button>
              <div className="btnIconDefault" onClick={this.toggleSettings}>
                <i className="fal fa-cog fa-spin" />
              </div>
            </div>
          </div>
          <div>
                  <Grid container item>
                    <Grid item sm={settingsCol ? 9 : 12} className={classes.marginGrid}>
                      <div className={classes.itemWrapper}>
                        <div className="form-control">
                              <input 
                                type="text" 
                                name={language === 'en'? "title_en" : language === 'ko' ? 'title_ko' : 'title_vi'}
                                className="input-control fullWidth"
                                value={language === 'en' ? title_en : language === 'ko' ? title_ko : title_vi}
                                placeholder={language === 'en'? "🇬🇧 Tiêu đề" : language === 'ko' ? '🇰🇷 Tiêu đề' : '🇻🇳 Tiêu đề'}
                                onChange={this.handleChange}
                                autoFocus
                              />
                        </div>
                      </div>
                      <div className={classes.itemWrapper}>
                        <Typography variant="body2" color="inherit" style={{marginBottom: 10, fontWeight: 500}}>
                          {language === 'en'? "🇬🇧 Mô tả dài" : language === 'ko' ? '🇰🇷 Mô tả dài' : '🇻🇳 Mô tả dài'}
                        </Typography>
                        <div className={classes.formEdit}>
                          <Editor
                            name={language === 'en'? "description_en" : language === 'ko' ? 'description_ko' : 'description_vi'}
                            editorState={language === 'en'? description_en : language === 'ko' ? description_ko : description_vi}
                            toolbarClassName="sticky-tools-bar"
                            wrapperClassName="body-wrapper"
                            editorClassName="body-editor"
                            onEditorStateChange={this.onDescriptionChange}
                            toolbarCustomButtons={[
                              <ImageFolder 
                                isInsertImageBody 
                                description={language === 'en'? description_en : language === 'ko' ? description_ko : description_vi} 
                                onUpdateChange={language === 'en'? (data) => this.setState({description_en: data}) : language === 'ko' ? (data) => this.setState({description_ko: data}) : (data) => this.setState({description_vi: data})}
                               />, 
                               <InsertYoutube />
                            ]}
                            handleKeyCommand={this.handleKeyCommand}
                            blockRendererFn={mediaBlockRenderer}
                            // toolbarOnFocus
                            toolbar={{
                              options: ['blockType', 'fontSize', 'inline', 'list', 'textAlign', 'colorPicker', 'remove', 'history', 'link', ],
                              blockType: {
                                className: 'textDark',
                              },
                              fontSize: {
                                className: 'textDark',
                              },
                              inline: {
                                  options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'],
                                  bold: { className: 'bordered-option-classname' },
                                  italic: { className: 'bordered-option-classname' },
                                  underline: { className: 'bordered-option-classname' },
                                  strikethrough: { className: 'bordered-option-classname' },
                                  superscript: { className: 'bordered-option-classname' },
                                  subscript: { className: 'bordered-option-classname' },
                              },
                              list: {
                                inDropdown: true,
                              },
                              colorPicker: {
                                  // icon: <BarChartIcon />,
                                  className: undefined,
                                  component: undefined,
                                  popupClassName: undefined,
                                  colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                                    'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                                    'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                                    'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                                    'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                                    'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
                                },
                                remove: { className: undefined, component: undefined },
                                history: {
                                      inDropdown: true,
                                      className: undefined,
                                      component: undefined,
                                      dropdownClassName: undefined,
                                      options: ['undo', 'redo'],
                                      undo: { className: undefined },
                                      redo: { className: undefined },
                                },
                                link: {
                                    inDropdown: true,
                                    popupClassName: 'demo-popup-custom',
                                    link: { className: 'demo-option-custom' },
                                    unlink: { className: 'demo-option-custom' },
                                },
                              }}
                            />
                          </div>
                      </div>
                      
                </Grid>
                {settingsCol &&
                <Grid item sm={3} className={classes.marginGrid}>
                    <div className={classes.itemWrapper}>
                        <Typography variant="body2" color="inherit" style={{marginBottom: 10, fontWeight: 500}}>
                            Trạng thái và hiển thị
                        </Typography>
                        <div className={classes.boxFlex}>
                          <div style={{minWidth: 100}}>
                            <Typography variant="body2" color="inherit" style={{marginBottom: 10}}>
                              Hiển thị
                            </Typography>
                          </div>
                          <div className="ml-auto">
                            <Typography className="textLink" variant="body2" style={{marginBottom: 10, color: '#ff5499'}} onClick={this.toggeShowActive}>
                              {status === 2
                              ? 'Được bảo vệ bằng mật khẩu'
                              : status === 0 
                              ? 'Riêng tư'
                              : 'Công khai'
                              }
                            </Typography>
                          </div>
                        </div>
                        {openShowActive &&
                          <div className={classes.box}>
                            <p><Checkbox className={classes.checkBox} onChange={() => this.changeActive(1)} checked={status === 1 ? true : false} /> Công khai</p>
                            <p><Checkbox className={classes.checkBox} onChange={() => this.changeActive(0)} checked={status === 0 ? true : false} /> Riêng tư</p>
                            <p><Checkbox className={classes.checkBox} onChange={() => this.changeActive(2)} checked={status === 2 ? true : false} /> Mật khẩu</p>
                            {onShowActivePw &&
                              <TextField
                                  autoFocus
                                  name="password"
                                  type="text"
                                  label="Mật khẩu"
                                  value={password}
                                  className={classes.textField}
                                  onChange={this.handleChange}
                                  onKeyDown={this.confirmActivePw}
                                  fullWidth
                              />
                            }
                          </div>
                        }
                        <div className={classes.boxFlex}>
                          <div style={{minWidth: 100}}>
                            <Typography variant="body2" color="inherit" style={{marginBottom: 10}}>
                              Đăng
                            </Typography>
                          </div>
                          <div className="ml-auto">
                            <Typography className="textLink" variant="body2" style={{marginBottom: 10, color: '#ff5499'}} onClick={this.toggeShowCreatedAt}>
                              {this.props.match.params.postId ? dayjs(createdAt).format('DD/MM/YYYY') : openNewCreatedAt ? dayjs(createdAt).format('DD/MM/YYYY') : 'Ngay'}
                            </Typography>
                          </div>
                        </div>
                        <div className={classes.boxFlex}>
                          <div style={{minWidth: 100}}>
                            <Typography variant="body2" color="inherit" style={{marginBottom: 10}}>
                              Ngôn ngữ
                            </Typography>
                          </div>
                          <div className="ml-auto flex">
                            <Typography className={`border-right ${language === 'vi' ? 'textLink' : ''}`} variant="body2" style={{marginBottom: 10, color: language === 'vi' ? '' : '#d7d7d7'}} onClick={() => this.setState({language: 'vi'})}>
                              VI
                            </Typography>
                            <Typography className={`border-right ${language === 'en' ? 'textLink' : ''}`} variant="body2" style={{marginBottom: 10, color: language === 'en' ? '' : '#d7d7d7'}} onClick={() => this.setState({language: 'en'})}>
                              EN
                            </Typography>
                            <Typography className={`${language === 'ko' ? 'textLink' : ''}`} variant="body2" style={{marginBottom: 10, color: language === 'ko' ? '' : '#d7d7d7'}} onClick={() => this.setState({language: 'ko'})}>
                              KO
                            </Typography>
                          </div>
                        </div>
                        {openShowCreatedAt &&
                        <div className={classes.box}>
                          <DateFormatInput 
                              name='createdAt' 
                              value={createdAt} 
                              selected={createdAt} 
                              onChange={this.onChangeCreatedAt}
                              label="Ngày đăng"
                              className={classes.dateInput}
                              fullWidth
                              dateFormat={(date) => dayjs(date).format('DD/MM/YYYY')}
                          />
                        </div>
                        }
                    </div>
                    <div className={classes.itemWrapper}>
                        <Typography variant="body2" color="inherit" style={{marginBottom: 10, fontWeight: 500}}>
                            Chuyên mục
                        </Typography>
                        {get_cate.map((category, index) => (
                          <div key={index}>
                          <p><Checkbox className={classes.checkBox} onChange={() => this.pushCategories({value: category.categoryId, label: category.name})} checked={categories.filter(item => item.value === category.categoryId).length > 0 ? true : false} /> {language === 'en' ? category.name.en ? category.name.en : category.name.vi : language === 'ko' ? category.name.ko ? category.name.ko : category.name.vi : category.name.vi}</p>
                          {
                            this.props.categories.categories_web.filter((element) => 
                            element.parentId.some((parent) => parent.value === category.categoryId))
                            .map(element => {
                                let n = Object.assign({}, element, {'parentId': element.parentId.filter(
                                  parent => parent.value === category.categoryId
                                )})
                                return n;
                            }).map((categoryChild) => (
                              <p className={classes.childCategory} key={categoryChild.categoryId}><Checkbox className={classes.checkBox} onChange={() => this.pushCategories({value: categoryChild.categoryId, label: categoryChild.name, parent: categoryChild.parentId})} checked={categories.filter(item => item.value === categoryChild.categoryId).length > 0 ? true : false}  /> {language === 'en' ? categoryChild.name.en ? categoryChild.name.en : categoryChild.name.vi : language === 'ko' ? categoryChild.name.ko ? categoryChild.name.ko : categoryChild.name.vi : categoryChild.name.vi}</p>
                            ))
                          }
                          </div>
                        ))}
                    </div>
                    <div className={classes.itemWrapper}>
                        <Typography variant="body2" color="inherit" style={{marginBottom: 10, fontWeight: 500}}>
                            Ảnh đại diện
                        </Typography>
                        {album_images &&
                          <div className={classes.showImageAlbum}>
                            {album_images}
                          </div>
                        }
                        <ImageFolder isFeaturedImage isFeaturedImageActive={featuredImg ? true : false} />
                    </div>
                </Grid>
                }
                <Grid item sm={9} className={classes.marginGrid} style={{borderTop: 0}}>
                  <div className={classes.itemWrapper}>
                      <Typography variant="body2" color="inherit" style={{marginBottom: 10, fontWeight: 500}}>
                        SEO
                      </Typography>
                      <BrowserSearch meta_title={language === 'en' ? meta_title_en : language === 'ko' ? meta_title_ko : meta_title_vi} meta_keywords={language === 'en' ? meta_keywords_en : language === 'ko' ? meta_keywords_ko : meta_keywords_vi} meta_description={language === 'en' ? meta_description_en : language === 'ko' ? meta_description_ko : meta_description_vi} slug={slug} domain={domain} title='Thẻ tiêu đề' />
                      <div className="form-control" style={{width: '100%', marginTop: 50}}>
                            <input 
                              type="text" 
                              name={language === 'en' ? "meta_title_en" : language === 'ko' ? "meta_title_ko" : "meta_title_vi"}
                              className="input-control fullWidth"
                              value={language === 'en' ? meta_title_en : language === 'ko' ? meta_title_ko : meta_title_vi}
                              placeholder={language === 'en' ? "🇬🇧 Thẻ tiêu đề" : language === 'ko' ? "🇰🇷 Thẻ tiêu đề" : "🇻🇳 Thẻ tiêu đề"}
                              onChange={this.handleChange}
                            />
                      </div>
                      <div className="flex">
                        <div className="form-control" style={{width: '100%'}}>
                            <input 
                              type="text" 
                              name="slug" 
                              className="input-control fullWidth"
                              value={slug}
                              placeholder="tieu-de"
                              onChange={this.handleChange}
                            />
                        </div>
                      </div>
                      <div className="form-control" style={{width: '100%'}}>
                        <textarea 
                            name={language === 'en' ? 'meta_description_en' : language === 'ko' ? 'meta_description_ko' : 'meta_description_vi'}
                            className="input-control fullWidth" 
                            rows="5"
                            placeholder={language === 'en' ? "🇬🇧 Thẻ mô tả" : language === 'ko' ? '🇰🇷 Thẻ mô tả' : '🇻🇳 Thẻ mô tả'}
                            value={language === 'en' ? meta_description_en : language === 'ko' ? meta_description_ko : meta_description_vi}
                            onChange={this.handleChange}
                          />
                      </div>
                      <div className="form-control" style={{width: '100%'}}>
                        <input 
                          type="text" 
                          name={language === 'en' ? "meta_keywords_en" : language === 'ko' ? "meta_keywords_ko" : "meta_keywords_vi"}
                          className="input-control fullWidth"
                          value={language === 'en' ? meta_keywords_en : language === 'ko' ? meta_keywords_ko : meta_keywords_vi}
                          onChange={this.handleChange}
                          placeholder={language === 'en'? "🇬🇧 Từ khoá tìm kiếm" : language === 'ko' ? '🇰🇷 Từ khoá tìm kiếm' : '🇻🇳 Từ khoá tìm kiếm'}
                        />
                      </div>
                      <ShowKeywords meta_keywords={language === 'en' ? meta_keywords_en : language === 'ko' ? meta_keywords_ko : meta_keywords_vi} />
                    </div>
                </Grid>
                <Grid item sm={3} className={classes.marginGrid} style={{borderTop: 0}}>
                  <div className={classes.itemWrapper}>
                    <Typography variant="body2" color="inherit" style={{marginBottom: 10, fontWeight: 500}}>
                      Đo lường SEO
                    </Typography>
                    <SEOAnalysis 
                      meta_title={language === 'en' ? meta_title_en : language === 'ko' ? meta_title_ko : meta_title_vi} 
                      meta_description={language === 'en' ? meta_description_en : language === 'ko' ? meta_description_ko : meta_description_vi} 
                      meta_keywords={language === 'en' ? meta_keywords_en : language === 'ko' ? meta_keywords_ko : meta_keywords_vi} 
                      title={language === 'en' ? title_en : language === 'ko' ? title_ko : title_vi}
                      description={language === 'en' ? description_en : language === 'ko' ? description_ko : description_vi}
                      slug={slug}
                      link={domain} />
                  </div>
                </Grid>
            </Grid> 
          </div>
      </Fragment>
    )
  }
}

PostForm.propTypes = {
  classes: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  getPost: PropTypes.func.isRequired,
  getAllCategoriesWeb: PropTypes.func.isRequired,
  postOnePost: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  clearImageSelected: PropTypes.func.isRequired,
  clearImage: PropTypes.func.isRequired,
  get_image: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  message: state.UI.message,
  loading: state.UI.loading,
  posts: state.posts,
  categories: state.categories,
  get_image: state.get_image,
});

export default connect(mapStateToProps, {getPost, updatePost, postOnePost, getAllCategoriesWeb, clearImageSelected, clearImage, clearErrors})(withStyles(styles)(PostForm));
